module.exports = __webpack_public_path__ + "static/seal-a9e6f267f88b2ecb74dd46a6ab4eb202.png";